export const DOC_OPTIONS = [
  { key: 'textbook', label: 'Textbook (Engagement Edition)', hint: 'Full chapters: examples, key ideas, diagrams, practice & answers' },
  { key: 'activities_booklet', label: 'Activity Booklet', hint: 'One hands-on activity + 20-mark chapter test per chapter' },
  { key: 'answer_key', label: 'Teacher Answer Key', hint: 'Model answers, marking guides, class mark sheet' },
  { key: 'study_guide', label: 'Student Study Guide', hint: 'One revision page per chapter' },
  { key: 'planning_workbook', label: 'Planning Workbook (Excel)', hint: 'Year Planner · Scheme of Work · Daily Lessons · Strategies · Assessment Plan — loads into the interactive planner' },
];

export const SUBJECTS = ['Mathematics', 'Basic Science', 'English', 'French', 'Social Science', 'Sciences sociales', 'ICT', 'Agriculture',
  'Home Economics', 'Chemistry', 'Physics', 'Biology', 'Economics', 'Accounting', 'Geography', 'History', 'Development Studies', 'Statistics', 'Calculus'];

export const STATUS_STYLE = {
  queued: 'bg-slate-100 text-slate-700', running: 'bg-amber-100 text-amber-800', done: 'bg-emerald-100 text-emerald-800', failed: 'bg-red-100 text-red-700',
};
